import { render } from "./Button.vue?vue&type=template&id=11318460&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-11318460"

export default script